import { 
  gql, 
  useQuery 
} from "@apollo/client";
import { 
  Community, 
  Customer, 
  FindCustomerByIdAdminQueryQuery, 
  FindCustomerByIdAdminQueryQueryVariables 
} from "../../../../../schemaTypes";

export const findCustomerByIdAdminQuery = gql`
  query FindCustomerByIdAdminQuery($id: String!) {
    findCustomerByIdAdmin(
      id: $id
    ) {
      customer{
        id
        firstname
        lastname
        username
        firstname
        lastname
        email
        phone
        dob
        nin
        bvn
        gender
        address
        referralCode
        referralPoint
        isAmbassador
      }
      userId
      cbmId
      suspended
      isLocked
      isDeactivated
      totalSpend
      currentBalance
      community{
        id
        alias
        name
      }
      location
    }
  }
`;

export interface WithFindCustomerByIdAdmin {
  customer: Customer | null;
  userId: string | null;
  cbmId: string | null;
  suspended: boolean | null;
  isLocked: boolean | null;
  isDeactivated: boolean | null;
  totalSpend: number | 0;
  currentBalance: number | 0;
  community: Community[] | null;
  location: string | null;
  loading: boolean;
}

interface Props {
  id: string;
  children: (data: WithFindCustomerByIdAdmin) => React.ReactElement | null;
}

export const FindCustomerByIdAdminController: React.FC<Props> = ({ id, children }) => {
  const { data, loading } = useQuery<
    FindCustomerByIdAdminQueryQuery, 
    FindCustomerByIdAdminQueryQueryVariables
  >(
    findCustomerByIdAdminQuery, {
      variables: { id }
    }
  );

  let customer: Customer | null = null;
  let userId: string | null = null;
  let cbmId: string | null = null;
  let suspended: boolean | null = null;
  let isLocked: boolean | null = null;
  let isDeactivated: boolean | null = null;
  let totalSpend = 0;
  let currentBalance = 0;
  let community: Community[] | null = null;
  let location: string | null = null; 

  if (data && data.findCustomerByIdAdmin) {
    customer = data.findCustomerByIdAdmin.customer as Customer;
    userId = data.findCustomerByIdAdmin.userId ?? null;
    cbmId = data.findCustomerByIdAdmin.cbmId ?? null;
    suspended = data.findCustomerByIdAdmin.suspended ?? null;
    isLocked = data.findCustomerByIdAdmin.isLocked ?? null;
    isDeactivated = data.findCustomerByIdAdmin.isDeactivated ?? null;
    totalSpend = data.findCustomerByIdAdmin.totalSpend ?? 0;
    currentBalance = data.findCustomerByIdAdmin.currentBalance ?? 0;
    community = data.findCustomerByIdAdmin.community?.filter((c): c is Community => c !== null) ?? null;
    location = data.findCustomerByIdAdmin?.location ?? null
  }

  return children({
    customer,
    userId,
    cbmId,
    suspended,
    isLocked,
    isDeactivated,
    totalSpend,
    currentBalance,
    community,
    location,
    loading
  });
};